import { initUtils } from "@tma.js/sdk";

export const telegramUtils = initUtils();
